import axios from "axios";
import {
  setInvoicingSteps,
  setInvoicingSubmiting,
  setInvoiceCreditButton,
} from "../../store/actions/navigation";

const key = process.env.REACT_APP_API_KEY;
const endpoint = `invoicing?code=${key}`;
const url = `/api/${endpoint}`;

export const adminInit = () => {
  return {
    type: "invoicing/init",
  };
};

const storeContractsList = (list) => {
  return {
    type: "invoicing/storeContractsList",
    payload: list,
  };
};

export const getContractsList = () => {
  return async (dispatch, getState) => {
    let order = await axios.post(`/api/invoicingGetTheOrder?code=${key}`, {});
    dispatch(
      setInvoicingSteps({
        ...getState().navigation.invoicing,
        linesOrder: order.data,
      }),
    );
    let response = await axios.get(`/api/invoicingContractsList?code=${key}`);
    dispatch(storeContractsList(response.data));
  };
};

export const setSelectedContract = (id) => {
  return {
    type: "invoicing/setSelectedContract",
    payload: id,
  };
};

export const storeContractDetails = (details) => {
  return {
    type: "invoicing/storeContractDetails",
    payload: details,
  };
};

export const getContractDetails = (id) => {
  return async (dispatch, getState) => {
    let response = await axios.get(
      `/api/invoicingContractDetails?code=${key}&&id=${id}`,
    );
    dispatch(storeContractDetails(response.data));
  };
};

export const nullContractDetails = () => {
  return {
    type: "invoicing/nullContractDetails",
  };
};
export const storeUnconifrmed = (contract) => {
  return {
    type: "invoicing/storeUnconifrmed",
    payload: contract,
  };
};
export const nullContractToConfirm = () => {
  return {
    type: "invoicing/nullContractToConfirm",
  };
};
export const updateUnconifrmed = (contract) => {
  console.log(contract);
  return async (dispatch, getstate) => {
    await axios.post(`/api/invoicingUpdateUnconifrmed?code=${key}`, {
      contract,
    });
    dispatch(nullContractToConfirm());
    dispatch(getUnconifrmedContracts());
  };
};
export const updateContractOrLines = (contract) => {
  console.log(contract);
  return async (dispatch, getstate) => {
    await axios.post(`/api/invoicingUpdateUnconifrmed?code=${key}`, {
      contract,
    });
    dispatch(nullContractDetails());
    dispatch(getContractDetails(contract.contractId));
  };
};

export const getUnconifrmedContracts = () => {
  return async (dispatch, getstate) => {
    let response = await axios.get(
      `/api/invoicingChangedContracts?code=${key}`,
    );
    dispatch(storeUnconifrmed(response.data));
  };
};

export const setInvoiceTwidEdit = (twidEdit) => {
  return {
    type: "invoicing/setInvoiceTwidEdit",
    payload: twidEdit,
  };
};
export const setOrderlineEndDateEdit = (qlineId) => {
  return {
    type: "invoicing/setOrderlineEndDateEdit",
    payload: qlineId,
  };
};
export const setOrderlineInvoiceDateEdit = (qlineId) => {
  return {
    type: "invoicing/setOrderlineInvoiceDateEdit",
    payload: qlineId,
  };
};

export const storeNewInvoices = (invoices) => {
  return {
    type: "invoicing/storeNewInvoices",
    payload: invoices,
  };
};

export const generateInvoices = (invoicingSteps) => {
  return async (dispatch, getState) => {
    if (invoicingSteps.invoicingDate) {
      dispatch(
        setInvoicingSteps({
          ...getState().navigation.invoicing,
          generatingInvoices: true,
        }),
      );

      console.log("get the order - busy");

      let response = await axios.post(
        `/api/invoicingGetTheOrder?code=${key}`,
        {},
      );

      dispatch(
        setInvoicingSteps({
          ...getState().navigation.invoicing,
          linesOrder: response.data,
        }),
      );

      console.log("clearing invoices - busy");
      response = await axios.post(
        `/api/invoicingClearInvoices?code=${key}`,
        {},
      );
      if (response.data === "True") {
        console.log("clearing invoices - done");
      } else {
        console.log("clearing invoices - fail");
        return;
      }

      if (invoicingSteps.generalInvoices) {
        console.log("General - creating regular invoice lines - busy");
        response = await axios.post(
          `/api/invoicingGeneralNewInvoiceLinesRegular?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("General - creating regular invoice lines - done");
        } else {
          console.log("General - creating regular invoice lines - fail");
          return;
        }
      }

      if (invoicingSteps.partnerFees) {
        console.log("Partner fees - creating invoice lines - busy");
        response = await axios.post(
          `/api/invoicingFeesNewInvoiceLines?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("Partner fees - creating invoice lines - done");
        } else {
          console.log("Partner fees - creating invoice lines - fail");
          return;
        }
      }

      if (invoicingSteps.internetSuitcases) {
        console.log("Internet Suitcases - creating invoice lines - busy");
        response = await axios.post(
          `/api/invoicingSuitcasesNewInvoiceLines?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("Internet Suitcases - creating invoice lines - done");
        } else {
          console.log("Internet Suitcases - creating invoice lines - fail");
          return;
        }
      }

      if (invoicingSteps.generalInvoices) {
        console.log("General - creating credit invoice lines - busy");
        response = await axios.post(
          `/api/invoicingGeneralNewInvoiceLinesCredit?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("General - creating credit invoice lines - done");
        } else {
          console.log("General - creating credit invoice lines - fail");
          return;
        }
      }

      if (invoicingSteps.generalInvoices) {
        console.log("General - correcting end dates - busy");
        response = await axios.post(
          `/api/invoicingGeneralCorrectingEndDates?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("General - correcting end dates - done");
        } else {
          console.log("General - correcting end dates - fail");
          return;
        }
      }

      if (invoicingSteps.generalInvoices) {
        console.log("General - setting quantities - busy");
        response = await axios.post(
          `/api/invoicingGeneralSettingQuantities?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("General - setting quantities - done");
        } else {
          console.log("General - setting quantities - fail");
          return;
        }
      }

      if (invoicingSteps.generalInvoices) {
        console.log("General - setting discounts - busy");
        response = await axios.post(
          `/api/invoicingGeneralDiscounts?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data === "True") {
          console.log("General - setting discounts - done");
        } else {
          console.log("General - setting discounts - fail");
          return;
        }
      }

      let generalInvoices = [];
      let feesInvoices = [];
      let usageInvoices = [];

      if (invoicingSteps.generalInvoices) {
        console.log("General - creating invoices - busy");
        response = await axios.post(
          `/api/invoicingGeneralCreatingInvoices?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data !== "False") {
          generalInvoices = response.data;
        } else {
          console.log("General - creating invoices - fail");
          return;
        }
      }
      if (invoicingSteps.partnerFees) {
        console.log("Partner fees - creating invoices - busy");
        response = await axios.post(
          `/api/invoicingFeesCreatingInvoices?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data !== "False") {
          feesInvoices = response.data;
        } else {
          console.log("General - creating invoices - fail");
          return;
        }
      }
      if (invoicingSteps.internetSuitcases) {
        console.log("Internet Suitcases - creating invoices - busy");
        response = await axios.post(
          `/api/invoicingSuitcasesCreatingInvoices?code=${key}`,
          {
            date: invoicingSteps.invoicingDate,
          },
        );
        if (response.data !== "False") {
          feesInvoices = response.data;
        } else {
          console.log("Internet Suitcases - creating invoices - fail");
          return;
        }
      }

      dispatch(
        storeNewInvoices([
          ...generalInvoices,
          ...feesInvoices,
          ...usageInvoices,
        ]),
      );
      dispatch(
        setInvoicingSteps({
          ...getState().navigation.invoicing,
          generatingInvoices: false,
          preSelSearchResults: [
            ...generalInvoices,
            ...feesInvoices,
            ...usageInvoices,
          ].map((invoice) => invoice.id),
          allInvoicesIds: [
            ...generalInvoices,
            ...feesInvoices,
            ...usageInvoices,
          ].map((invoice) => invoice.id),
        }),
      );
    }
  };
};
export const submitInvoices = (invoices) => {
  return async (dispatch, getState) => {
    dispatch(setInvoicingSubmiting(true));
    dispatch(
      setInvoicingSteps({
        ...getState().navigation.invoicing,
      }),
    );
    let apiRes = await axios.post(
      `/api/invoicingSubmitNewInvoice?code=${key}`,
      {
        invoices,
      },
    );

    if (apiRes.data !== "fail") {
      for (let invoice of invoices.invoices) {
        console.log(
          getState().invoicing.newInvoices.findIndex(
            (inv) => inv.id === invoice.invoiceId,
          ),
        );
        let newInvoices = getState().invoicing.newInvoices;
        newInvoices[
          newInvoices.findIndex((inv) => inv.id === invoice.invoiceId)
        ].state = `submited`;
        newInvoices[
          newInvoices.findIndex((inv) => inv.id === invoice.invoiceId)
        ].message = `Invoice submited with id: ${apiRes.data}`;
        dispatch(storeNewInvoices(newInvoices));
        dispatch(setInvoicingSubmiting(false));
      }
    } else {
      for (let invoice of invoices.invoices) {
        console.log(
          getState().invoicing.newInvoices.findIndex(
            (inv) => inv.id === invoice.invoiceId,
          ),
        );
        let newInvoices = getState().invoicing.newInvoices;
        newInvoices[
          newInvoices.findIndex((inv) => inv.id === invoice.invoiceId)
        ].state = `failed`;
        newInvoices[
          newInvoices.findIndex((inv) => inv.id === invoice.invoiceId)
        ].message = `Invoice submission failed`;

        dispatch(storeNewInvoices(newInvoices));
        dispatch(setInvoicingSubmiting(false));
      }
    }
  };
};
export const submitCrediting = (invoices) => {
  return async (dispatch, getState) => {
    console.log("duoa");
    dispatch(setInvoicingSubmiting(true));
    dispatch(setInvoiceCreditButton(true));
    let apiRes = await axios.post(`/api/invoicingSubmitCrediting?code=${key}`, {
      invoices,
    });
    dispatch(getInvoiceDetails(invoices.invoiceNr));
    console.log(apiRes);
    console.log(invoices);

    if (apiRes.data !== "fail") {
      dispatch(setInvoiceCreditButton(false));
      dispatch(setInvoicingSubmiting(false));
    } else {
      dispatch(setInvoiceCreditButton(true));
      dispatch(setInvoicingSubmiting(false));
    }
  };
};
export const removeInvoice = (invoices) => {
  return async (dispatch, getState) => {
    dispatch(setInvoicingSubmiting(true));

    let arr = getState().navigation.invoicing.includedInvoicesIds;
    let arr2 = getState().navigation.invoicing.allInvoicesIds;
    for (let invoice of invoices.invoices) {
      arr.splice(arr.indexOf(invoice.invoiceId), 1);
      arr2.splice(arr.indexOf(invoice.invoiceId), 1);
    }
    dispatch(
      setInvoicingSteps({
        ...getState().navigation.invoicing,
      }),
    );
    let arr3 = [];
    for (let newInvoice of [...getState().invoicing.newInvoices]) {
      if (
        !invoices.invoices.map((inv) => inv.invoiceId).includes(newInvoice.id)
      ) {
        arr3.push(newInvoice);
      }
    }

    dispatch(storeNewInvoices(arr3));
    dispatch(
      setInvoicingSteps({
        ...getState().navigation.invoicing,
      }),
    );
    dispatch(setInvoicingSubmiting(false));
  };
};
export const updateInvoiceNumber = (data) => {
  return async (dispatch, getState) => {
    console.log(data);
    await axios.post(`/api/invoicingUpdateInvoiceNumber?code=${key}`, {
      data,
    });
  };
};
export const storePastInvoices = (invoices) => {
  return {
    type: "invoicing/storePastInvoices",
    payload: invoices,
  };
};
export const getPastInvoices = () => {
  return async (dispatch, getstate) => {
    let response = await axios.get(`/api/invoicinGetPastInvoices?code=${key}`);
    dispatch(storePastInvoices(response.data));
    console.log(response.data);
  };
};
export const storeInvoiceDetails = (invoices) => {
  return {
    type: "invoicing/storeInvoiceDetails",
    payload: invoices,
  };
};
export const getInvoiceDetails = (invoice) => {
  return async (dispatch, getstate) => {
    let order = await axios.post(`/api/invoicingGetTheOrder?code=${key}`, {});
    let response = await axios.get(
      `/api/invoicingInvoiceDetails?code=${key}&&invoice=${invoice}`,
    );
    if (response.data[0].credited) {
      dispatch(setInvoiceCreditButton(false));
    }

    dispatch(
      setInvoicingSteps({
        linesOrder: order.data,
      }),
    );
    dispatch(storeInvoiceDetails(response.data));
  };
};
